import requests from '@/axios/index.js'
const req = requests.requests
export default {
    /** 获取考题列表 */
    getList: () => req.get('/api/Exam/GetQuestionList'),
}
